import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Menu } from "semantic-ui-react";
import { SETUP_PAGES } from "constants/pages";

function SetupBarTablet(props) {
  const { currentPageKey } = props;
  const { t } = useTranslation("common");
  return (
    <Menu secondary size="small" className="app-bar" pointing>
      {SETUP_PAGES.map((page) => (
        <Menu.Item key={page.key} as={Link} to={page.path} active={page.key === currentPageKey}>
          {t(page.tKey)}
        </Menu.Item>
      ))}
    </Menu>
  );
}

export default SetupBarTablet;
